// src/pages/locations/tabs/RegionsTab.tsx
import React from "react";
import { useNavigate } from "react-router-dom";

import ConfirmDialog from "@/components/shared/ui/ConfirmDialog";
import RegionsTable from "@/components/locations/regions/RegionsTable";

import { useRegionsList } from "../hooks/useRegionsList";
import { useLocationScope } from "../useLocationScope";
import { locationEditPath } from "../locations.access";
import { RefreshingStrip, SelectCountryNotice } from "../components/LocationFilters";

const RegionsTab: React.FC = () => {
  const navigate = useNavigate();
  const { country, search, scope } = useLocationScope();

  const {
    filters,
    setFilters,
    page,
    setPage,
    pageSize,
    rows,
    total,
    isLoading,
    isFetching,
    deleting,
    confirmDelete,
    askDelete,
    cancelDelete,
    confirmDeleteRow,
  } = useRegionsList({ countryIso2: country, search });

  return (
    <>
      <RefreshingStrip show={isFetching && !isLoading && Boolean(country)} />

      {!country ? (
        <SelectCountryNotice entity="regions" />
      ) : (
        <RegionsTable
          rows={rows}
          page={page}
          pageSize={pageSize}
          total={total}
          isLoading={isLoading || isFetching}
          filters={filters}
          setFilters={setFilters}
          onPageChange={setPage}
          onEdit={(row) => navigate(locationEditPath("regions", row.id, scope))}
          onDelete={askDelete}
          countryIso2={country}
        />
      )}

      <ConfirmDialog
        open={confirmDelete.open}
        title="Delete region"
        message={
          confirmDelete.row
            ? `Delete region "${confirmDelete.row.name}"?`
            : "Delete this region?"
        }
        confirmText={deleting ? "Deleting…" : "Delete"}
        cancelText="Cancel"
        onCancel={cancelDelete}
        onConfirm={confirmDeleteRow}
      />
    </>
  );
};

export default RegionsTab;
